import React, { useState, useMemo, useEffect } from 'react'
import PriceRange from '../atoms/price-range/PriceRange'
import styles from './plannerListStyle.module.scss'
import LocationDropdown from '../vendors-list/LocationDropdown'
import { useDispatch, useSelector } from 'react-redux'
import {
	getPlannerFieldValues,
	setPlannerFilters,
} from '../../features/plannerSlice'
import { useDebouncedCallback } from '../../hooks'
import MultiselectSearch from '../atoms/select/MultiSelect'
import { ALL_STACKS, profilePics } from '../../util/constants'

const PlannerFilterForm = ({ clear }) => {
	const dispatch = useDispatch()
	const plannerFilters = useSelector((state) => state.planner.plannerFilters)
	const businessTypes = useSelector(
		(state) => state.planner.plannerFieldValues?.['businessType']
	)
	const [data, setData] = useState({
		lowerPriceRange: 0,
		upperPriceRange: 500000,
	})
	const [types, setTypes] = useState([])

	const plannerTypes = useMemo(() => {
		if (!businessTypes?.length) return []
		return [...new Set(ALL_STACKS.concat(businessTypes))].map(
			(name, i) => ({
				_id: i + 1,
				name,
				profilePic: profilePics[i] || '/images/ontimebride_iconset_blue_vendor_default.png',
			})
		)
	  }, [businessTypes]);

	const handleChange = (k, v) =>
		dispatch(setPlannerFilters({ ...plannerFilters, page: 1, limit: 10, [k]: v }))

	const debouncePriceRange = useDebouncedCallback((lower, upper) => {
		dispatch(
			setPlannerFilters({
				...plannerFilters,
				page: 1,
				limit: 10,
				lowerPriceRange: lower,
				upperPriceRange: upper,
			})
		)
	}, 1000)

	const handleMultiSelect = (v) =>
		setTypes((prev) => {
			const exists = prev.some((item) => item._id === v._id)
			if (exists) return prev
			return [...prev, v]
		})

	const handleMultiRemove = (v) => {
		setTypes((prev) => prev.filter((x) => x._id !== v))
	}

	useEffect(() => {
		if (types.length > 0) {
			const typeString = types.map((t) => t.name).join(',')
			handleChange('types', typeString)
		} else {
			handleChange('types', '')
		}
	}, [types])

	useEffect(() => {
		if (clear) {
			setData({
				lowerPriceRange: 100,
				upperPriceRange: 500,
			})
			setTypes([])
		}
	}, [clear])

	useEffect(() => {
		dispatch(setPlannerFilters({}))
		dispatch(getPlannerFieldValues({ fieldName: 'businessType' }))
	}, [dispatch])

	return (
		<form action="">
			<div className={styles.formGroup}>
				<label htmlFor="type" className={styles.formLabel}>
					Type
				</label>
				<MultiselectSearch
					members={plannerTypes}
					selected={types}
					onSelect={handleMultiSelect}
					onRemove={handleMultiRemove}
					placeholder="Select a type"
					searchPlaceholder="Search a type..."
				/>
			</div>
			<div className={styles.formGroup}>
				<label htmlFor="Location" className={styles.formLabel}>
					Location
				</label>

				<LocationDropdown
					value={plannerFilters?.businessAddress || ''}
					onChange={(val) => handleChange('businessAddress', val)}
				/>
			</div>
			<div className={styles.formGroup}>
				<label htmlFor="PriceRange" className={styles.formLabel}>
					Price Range
				</label>
				<PriceRange
					userDetails={data}
					setUserDetails={(v) => {
						setData(v)
						debouncePriceRange(v.lowerPriceRange, v.upperPriceRange)
					}}
				/>
			</div>
		</form>
	)
}

export default PlannerFilterForm
